"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisualAccessible = void 0;
var react_1 = __importDefault(require("react"));
var __1 = require("..");
var VisualAccessible = function (_a) {
    var children = _a.children, accessibleLabel = _a.accessibleLabel;
    var VisuallyHidden = (0, __1.useComponents)().VisuallyHidden;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(VisuallyHidden, null, accessibleLabel),
        react_1.default.createElement("span", { "aria-hidden": "true" }, children)));
};
exports.VisualAccessible = VisualAccessible;
